import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.system.dashboard');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-system-dashboard',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.lpsysadmin.system.dashboard/view.scss */
:host {
  display: block;
  width: 100%;
  height: 100%;
}`],
})
export class PortalLpsysadminSystemDashboardComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }

    public go(path: string) {
        this.service.href(path);
    }

    public isSuperAdmin(): boolean {
        return this.service.auth?.session?.membership === 'super_admin';
    }

    public hrRecordsLink(): string {
        return this.isSuperAdmin() ? '/admin/system/hr-records' : '/admin/system/my-hr-records';
    }

    public attendanceLink(): string {
        return this.isSuperAdmin() ? '/admin/system/attendance' : '/admin/system/my-attendance';
    }

    public leaveLink(): string {
        return this.isSuperAdmin() ? '/admin/system/leave' : '/admin/system/my-leave';
    }

    public hrRecordsLabel(): string {
        return this.isSuperAdmin() ? '인사기록카드' : '내 인사기록카드';
    }

    public attendanceLabel(): string {
        return this.isSuperAdmin() ? '근태관리' : '내 근태관리';
    }

    public leaveLabel(): string {
        return this.isSuperAdmin() ? '휴가관리' : '내 휴가관리';
    }
}

export default PortalLpsysadminSystemDashboardComponent;